import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'mdk-modal',
  templateUrl: './modal.component.html'
})
export class ModalComponent implements AfterViewInit {
  @Input() id!: string;
  @Input() title!: string;
  @Input() closable? = true;
  @Input() large? = false;

  @ViewChild('modalRef')
  modalRef!: ElementRef<HTMLDialogElement>;

  private preventArrowKeyNavigation() {
    this.modalRef.nativeElement.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.stopPropagation(); // Prevents the event from reaching the tabs
      }
    });
  }

  ngAfterViewInit() {
    this.initializeWebUniversumModal();
    this.preventArrowKeyNavigation();
  }

  private initializeWebUniversumModal() {
    window.vl.modal.dress(this.modalRef.nativeElement);
  }
}
